export function LoadingScreen() {
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-6 p-6">
      <div className="w-16 h-16 rounded-full border-4 border-white/10 border-t-accent animate-spin" />
      <div className="font-display text-3xl text-white tracking-wide">World of Waifu</div>
      <div className="text-white/50 text-sm">Loading...</div>
    </div>
  );
}
